<template>
    <div style="padding-top: 90px;">

      <div style="margin: 5px;">
        <!-- 广告 -->
        <el-row :gutter="0">
  
          <el-col :xs="12*item.span" :sm="6*item.span" :md="6*item.span" :lg="4*item.span" v-for="(item,index) in PageData.indexadlist" :key="index"><!-- style="margin-bottom: -10px" -->

            <a :href="item.url" target="_blank">
              <el-image :title="item.title" error="@/assets/no_img.png" style="width: 100%;height: 100%;text-align: center;" class="" :src="item.image" fit="cover" >
                <template #error>
                  <div style="background-color: #000;color: #fff;">{{ item.title }}</div>
                </template>
              </el-image>
            </a>
  
          </el-col>
  
        </el-row>
      </div>
  
  
  
      <div class="size-body" v-loading="loading" element-loading-background="rgba(17, 17, 17, 0.8)">

        <div>
          <div class="title-s">
            {{ type.type0==1?'영화':'' }}<!-- 电影 -->
            {{ type.type0==2?'드라마':'' }}<!-- 电视剧 -->
            {{ type.type0==3?'예능':'' }}<!-- 综艺/娱乐 -->
            {{ type.type0==4?'시사':'' }}<!--  综艺/娱乐 -->
            {{ type.type0==5?'애니메이션':'' }}<!-- 时事/教养 -->
            {{ type.type0==6?'OTT예능':'' }}<!-- YouToBe -->
            {{ type.type0==9?'지난드라마':'' }}<!-- 完结的电视剧 -->
          </div>
  
          <el-row :span="24" :gutter="0" style="padding: 10px;min-height: 200px;" class="row-bg">
            <el-col :xs="8" :sm="6" :lg="3" class="card" style="position: relative;" v-for="(item,index) in PageData.List" :key="index" >
              
                <!-- <span v-if="item.ending==0" class="ending">완결</span>
                <span v-else class="ending">제 {{ item.ending }} 화</span> -->
                <span v-if="item.today==1" class="ending">Today</span>
                
                <router-link :to="'/Detail?id='+item.id">

                  <el-card shadow="hover" :body-style="{ padding: '0px', width: '100%' }"
                      style="margin: 3px 3px;border: 0;border-radius: 5px;background-color: #000;">
                      <span>
                      <el-image style="width: 100%; aspect-ratio: 9/13;border-radius: 5px 5px 0 0;text-align: center;" :src="item.image" fit="cover">
                          <div slot="error">
                          <img src="@/assets/no_img.png" style="width: 100%; aspect-ratio: 9/13;text-align: center;"
                              fit="cover">
                          </div>
                          <div slot="placeholder">
                          <img src="@/assets/loading.gif" style="width: 100%; aspect-ratio: 9/13;text-align: center;"
                              fit="cover">
                          </div>
                      </el-image>
                      </span>
                      

                      <div style="margin: 0 8px;padding: 3px 0;min-height: 40px;">
                      <el-tooltip transition="" effect="dark" :content="item.intor" placement="top">
                          <div class="one_line" style="color: #ddd;font-size: 0.9rem;width:100%;text-align: left;">
                          <div>{{ item.title }}</div>
                          <div>
                            <!-- {{ item.star }} -->
                            <span v-if="item.ending==0">완결</span>
                            <span v-else>제 {{ item.ending }} 화</span>
                          </div>
                          </div>
                      </el-tooltip>
                      </div>

                  </el-card>

                </router-link>
  
            </el-col>
          </el-row>
        </div>


        <div style="margin: 50px 0;text-align: center;">

            <el-pagination
                background
                layout="prev,pager, next" 
                @prev-click="prevPage"
                @next-click="nextPage"
                @current-change="currentChange"
                :pager-count="5"
                :page-size="32"
                :current-page="type.page"
                :total="PageData.Total">
            </el-pagination>

        </div>
  

      </div>
      
    </div>
  </template>
  
  <script>
  export default {
    name: 'TypeView',
    components: {
  
    },
    data(){
      return{
        loading:true,
        type_temp_type0:0,
        PageData:{
            pageTotal:0,
            Total:0,
            indexadlist:[],
            adlist:[],
            List:[]
        },
        type:{
            type0:0,
            type1:0,
            type2:0,
            type3:0,
            type4:0,
            order:0,
            page:1,
        },
      }
    },
    created() {
    
        this.type.page = this.$route.query.page==undefined?1:parseInt(this.$route.query.page)
        this.type.type0 = this.$route.query.type==undefined?0:this.$route.query.type
        this.type.type1 = this.$route.query.type1==undefined?0:this.$route.query.type1
        this.type.type2 = this.$route.query.type2==undefined?0:this.$route.query.type2
        this.type.type3 = this.$route.query.type3==undefined?0:this.$route.query.type3
        this.type.type4 = this.$route.query.type4==undefined?0:this.$route.query.type4

    },
    mounted() {
        
        this.type.page = this.$route.query.page==undefined?1:parseInt(this.$route.query.page)
        this.type.type0 = this.$route.query.type==undefined?0:this.$route.query.type
        this.type.type1 = this.$route.query.type1==undefined?0:this.$route.query.type1
        this.type.type2 = this.$route.query.type2==undefined?0:this.$route.query.type2
        this.type.type3 = this.$route.query.type3==undefined?0:this.$route.query.type3
        this.type.type4 = this.$route.query.type4==undefined?0:this.$route.query.type4

        if(this.type_temp_type0 !== this.type.type0){
            this.type_temp_type0 = this.type.type0
            this.type.page = 1
        }

        // this.loadType()
        this.loadPage()

    },
    watch: {
        // 监听路由对象 $route 的变化
        '$route': {
        handler: function (to, from) {
            // 路由变化时执行的操作
            this.loading = true
            // console.log(this.$route.query)
            this.type.page = this.$route.query.page==undefined?1:parseInt(this.$route.query.page)
            // console.log(this.type.page)
            
            this.type.type0 = this.$route.query.type==undefined?0:this.$route.query.type
            this.type.type1 = this.$route.query.type1==undefined?0:this.$route.query.type1
            this.type.type2 = this.$route.query.type2==undefined?0:this.$route.query.type2
            this.type.type3 = this.$route.query.type3==undefined?0:this.$route.query.type3
            this.type.type4 = this.$route.query.type4==undefined?0:this.$route.query.type4



            if(this.type_temp_type0 !== this.type.type0){
                this.type_temp_type0 = this.type.type0
                this.type.page = 1
            }

            var element = document.getElementById('pagetop');
            element.scrollIntoView({ behavior: "smooth" });
            

            // this.loadType()
            this.loadPage()
        },
        // 设置为深度监听
        deep: true
        }
    },
    methods: {
        loadPage(){
            var this_ = this

            this_.PageData.List = []

            // console.log(">>",this_.type.page)

            this.httpinfo.GetInfo(this,this.baseURL + "type?mark="+this.baseMark+"&limit=24&type0="+this_.type.type0+"&type1="+this_.type.type1+"&type2="+this_.type.type2+"&type3="+this_.type.type3+"&type4="+this_.type.type4+"&order="+this_.type.order+"&page="+this_.type.page, function(e) {
                if(e.data.code==0){

                this_.PageData.pageTotal = e.data.pagecount
                this_.PageData.Total = e.data.count

                this_.PageData.adlist = e.data.data.adlist
                // this_.PageData.adlist.sort(() => Math.random() - 0.5) //随机位置
                this_.PageData.indexadlist = e.data.data.indexadlist
                // this_.PageData.indexadlist.sort(() => Math.random() - 0.5) //随机位置

                let Temp_Rand_Arr = [],Temp_No_Rand_Arr = []
                this_.PageData.adlist.forEach(function(item){
                    if(item.rand=='0'){
                    Temp_Rand_Arr.push(item)
                    }else{
                    Temp_No_Rand_Arr.push(item)
                    }
                })
                Temp_Rand_Arr.sort(() => Math.random() - 0.5) //随机位置
                this_.PageData.adlist = Temp_No_Rand_Arr.concat(Temp_Rand_Arr) //合并数组

                Temp_Rand_Arr = [],Temp_No_Rand_Arr = []
                this_.PageData.indexadlist.forEach(function(item){
                    if(item.rand=='0'){
                    Temp_Rand_Arr.push(item)
                    }else{
                    Temp_No_Rand_Arr.push(item)
                    }
                })
                Temp_Rand_Arr.sort(() => Math.random() - 0.5) //随机位置
                // this_.PageData.indexadlist = Temp_No_Rand_Arr.concat(Temp_Rand_Arr) //合并数组

                Temp_No_Rand_Arr.forEach(function(item){
                    Temp_Rand_Arr.splice(item.location_num-1,0,item)
                })
                this_.PageData.indexadlist = Temp_Rand_Arr



                e.data.data.list.forEach(element => {
                    this_.PageData.List.push(element)
                });

                }else{
                
                this_.$message.error(e.data.msg)

                }
                this_.loading = false

            });
        },
        prevPage(e){
            // console.log(e)
        },
        nextPage(e){
            // console.log(e)
        },
        currentChange(e){
            this.type.page = e
            // this.loadPage()
            // console.log(e)

            this.goTo("Type?type="+this.type.type0+"&type1="+this.type.type1+"&type2="+this.type.type2+"&type3="+this.type.type3+"&type4="+this.type.type4+"&order="+this.type.order+"&page="+e)
        },
        goTo(path) {
            if (path !== this.$router.currentRoute.fullPath) {
                // console.log(path)
                this.loading = true
                this.$router.push(path);
            }
        },
    }
  }
  </script>
  <style>
  
  </style>
  